import { env } from '@/config/env';

/**
 * Canonical links to the published legal documents. They live on the marketing
 * site (syncanix.com), so the dashboard links out to that origin. Sourced from
 * VITE_MARKETING_URL with a production fallback, and trailing-slash-normalised
 * so `${BASE}/terms` never double-slashes.
 *
 * Single source of truth for: the dashboard LegalFooter, the billing
 * consent copy, and any future in-app legal reference.
 */
const MARKETING_BASE = (env.VITE_MARKETING_URL ?? 'https://www.syncanix.com').replace(/\/+$/, '');

export const TERMS_URL = `${MARKETING_BASE}/terms`;
export const PRIVACY_URL = `${MARKETING_BASE}/trust/privacy`;
export const REFUNDS_URL = `${MARKETING_BASE}/trust/refunds`;
export const COOKIES_URL = `${MARKETING_BASE}/cookies`;
export const DPA_URL = `${MARKETING_BASE}/trust/dpa`;
export const AI_DISCLOSURE_URL = `${MARKETING_BASE}/trust/ai`;
export const TRUST_CENTER_URL = `${MARKETING_BASE}/trust`;
/**
 * The public data-subject request form (GDPR Art. 15/17/20). The dashboard
 * points at it wherever a surface's scope stops short of the transcript plane —
 * the per-user export (UGL-207) is the first — so an operator asked for
 * something this product does not hand over knows where the request actually
 * goes, rather than assuming the download covered it.
 */
export const DSAR_URL = `${MARKETING_BASE}/trust/dsar`;

export interface LegalLink {
  /** i18n key for the link label — resolved by the consumer via `useT()`. */
  readonly labelKey: string;
  readonly href: string;
}

/** Footer link set, in display order. */
export const LEGAL_LINKS: readonly LegalLink[] = [
  { labelKey: 'footer.termsLink', href: TERMS_URL },
  { labelKey: 'footer.privacyLink', href: PRIVACY_URL },
  { labelKey: 'footer.refundsLink', href: REFUNDS_URL },
  { labelKey: 'footer.cookiesLink', href: COOKIES_URL },
  { labelKey: 'footer.dpaLink', href: DPA_URL },
  { labelKey: 'footer.aiDisclosureLink', href: AI_DISCLOSURE_URL },
  { labelKey: 'footer.trustCenterLink', href: TRUST_CENTER_URL },
];
